/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';
import {AppSharedModule} from '../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule],
  selector: 'adn-report-url-component',
  template: `
    <span *ngIf="!model?.reportUrl">URL not yet available</span>
    <a *ngIf="model?.reportUrl" [href]="safeReportUrl" target="_blank">
      <small>{{ safeReportUrl }}</small>
    </a>
  `
})
export class ReportUrlComponent implements OnChanges {
  @Input() model: {reportUrl?: string};
  safeReportUrl = '';

  ngOnChanges(): void {
    let url = this.model?.reportUrl || '';
    if (_.startsWith(url, '//')) {
      url = `https:${url}`;
    }
    this.safeReportUrl = url;
  }
}
